<template>
  <div class="d-flex" v-if="engagement">
    <span
      :class="'mr-2 ' + inherit ? '' : 'subtitle-1 secondarytext--text'"
      style="min-width: 35px;"
    >
      {{ engagement.completion | no_decimal }}%
    </span>
    <v-progress-linear
      class="rounded-sm my-auto"
      :value="engagement.completion"
      background-color="background"
      :color="
        $coreScores.getColor($coreScores.reverseFormat(engagement.completion))
      "
      height="8"
    ></v-progress-linear>
  </div>
</template>

<script>
export default {
  name: "SimpleEngagementText",
  props: {
    engagement: { type: Object },
    inherit: { type: Boolean, default: false }
  }
};
</script>
